import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationPayLater = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationPayLater',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_28405_76241)",
    fillRule: "evenodd",
    d: "M3 44.06h69.76V27.14c0-2.21-1.79-4-4-4H13c-5.52 0-10 4.48-10 10v10.92Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_28405_76241)",
    fillRule: "evenodd",
    d: "M48.02 3.467c2.7-2.592 7.1-2.64 9.92-.142l.14.124 22.79 21.27c2.77 2.584 2.87 6.747.26 9.387l-.13.123L43.62 70.09c-2.7 2.592-7.1 2.64-9.92.142l-.13-.133-22.8-21.28c-2.77-2.584-2.87-6.747-.26-9.387l.13-.123L48.02 3.467Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_28405_76241)",
    fillRule: "evenodd",
    d: "M30.9 41.26H13.4C7.65 41.26 3 38.85 3 33.1v49.39c0 5.74 4.66 10.4 10.4 10.4h66.26c2.2 0 3.99-1.78 3.99-3.99V45.25c0-2.2-1.78-3.99-3.99-3.99H30.9Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_28405_76241)",
    d: "M96.69 77.58c2.14-13.53-7.09-26.25-20.62-28.39-13.53-2.14-26.25 7.09-28.39 20.62-2.15 13.54 7.09 26.25 20.62 28.39 13.54 2.15 26.25-7.09 28.39-20.62Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M75.79 72.93V61.97a4.6 4.6 0 0 0-9.2 0v14.39l.01.17c.04 1.05.43 2.05 1.12 2.85l6.74 7.79a4.605 4.605 0 0 0 6.49.47 4.605 4.605 0 0 0 .47-6.49l-4.5-5.2a4.599 4.599 0 0 1-1.13-3.02Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_28405_76241",
    x1: -3.657,
    x2: 69.431,
    y1: 33.419,
    y2: 33.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.123,
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.595,
    stopColor: "#4A68FB"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_28405_76241",
    x1: 87.179,
    x2: 23.116,
    y1: -0.729,
    y2: 64.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.031,
    stopColor: "#FADBBD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.243,
    stopColor: "#D9ACD4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.446,
    stopColor: "#BF88E7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.634,
    stopColor: "#AD6DF4"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.802,
    stopColor: "#A25EFC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.934,
    stopColor: "#9E58FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_28405_76241",
    x1: 88.792,
    x2: 7.693,
    y1: 26.994,
    y2: 89.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#DAC0CB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.5,
    stopColor: "#8870F5"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#745DFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_28405_76241",
    x1: 56.097,
    x2: 133.912,
    y1: 90.848,
    y2: 7.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.049,
    stopColor: "#872FF9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.422,
    stopColor: "#A37CCF"
  }))));
};
ColoredIllustrationPayLater.displayName = 'ColoredIllustrationPayLater';
export default withProvisionalOverrideFromContext(ColoredIllustrationPayLater);
//# sourceMappingURL=index.js.map